<script setup lang="ts">
import { CardChallengeType } from '@/types/leaderboard-player'
import { useCardChallengeLeaderboard } from '@/composables/game/leader-board'
import router from '@/router'
import { RouteName } from '@/routes'
import { useDailyUpChallenge } from '@/composables/game/challenges'
import CardsScoreImage from '@/assets/images/cards.png'
import BaseChallengeModal from '@/components/modals/BaseChallengeModal.vue'
import DailyUpBackgroundImage from '@/assets/images/challenge-cards.png'
import DailyUpIcon from '@/assets/images/gifs/trophy.gif'

defineProps<{
	show: boolean,
}>()
const emit = defineEmits(['hide'])

const { formattedCountdown, dailyUpChallenge } = useDailyUpChallenge()
const {
  getCardChallengeLeaderboard,
  cardChallengeLeaderboard: players,
  currentPlayer,
} = useCardChallengeLeaderboard()

function onCtaClick() {
  router.push(RouteName.MINE)
}

async function getLeaderboard() {
  await getCardChallengeLeaderboard(CardChallengeType.DAILY)
}
</script>
<template>
  <BaseChallengeModal
    :show="show"
    :challenge="dailyUpChallenge"
    :formatted-countdown="formattedCountdown"
    :on-cta-click="onCtaClick"
    :get-leaderboard="getLeaderboard"
    :players="players"
    :current-player="currentPlayer"
    background-color="bg-[linear-gradient(180deg,#FF9D0A_0.01%,#4E5EB8_16.5%,#000_42.5%)]"
    :background-image="DailyUpBackgroundImage"
    :main-image="DailyUpIcon"
    main-image-class="size-[144px]"
    main-image-background-class="size-[154px] bg-[rgba(231,46,109,0.44)] blur-[36px]"
    :with-stars="true"
    timer-background-class="bg-[linear-gradient(90deg,#FF9D0A_6.18%,#4E5EB8_53.24%,#000_86.74%)]"
    title="Daily’ Up"
    description="Upgrade the most cards (level 9+) daily to earn rewards! You must be level 20+ and "
    cta-text="UPGRADE NOW"
    rule-card-line1="Upgrade"
    rule-card-line2="Cards"
    :rule-card-image="CardsScoreImage"
    :score-image="CardsScoreImage"
    @hide="emit('hide')"
  />
</template>
